<template>
  <div class="con-present">
    <div class="con-present-header display-mobile">
      <h2>
        <div class="pastTag">
          {{lecture.is_previous?'往届热门议题':''}}
        </div>
        <div>{{lecture.title}}</div>
      </h2>
      <!-- {{lecture.topic}} -->
      <template v-if="lecture.topic">
        <router-link :to="'/track/' + lecture.topic.id">
          <h3 class="belongsto">所属专题：{{lecture.topic.topic}}</h3>
          <h3 class="belongstoarea" v-if="lecture.tag_ids && lecture.tag_ids.length">
            所属领域：
            <span v-for="(tid, indexT) in lecture.tag_ids" :key="indexT">
              {{tags[tid].name + (indexT !== (lecture.tag_ids.length - 1) ? '、': '')}}
            </span>
          </h3>
        </router-link>
      </template>
      <h3 class="guest" v-if="lecture.speakerIds.length">
        嘉宾 :
        <span v-for="(sid, idx) in lecture.speakerIds" :key="idx">
          <span v-if="lecture.speakerIds.length>1">{{'('+(idx+1)+')'}}</span> {{speakers[sid].name}} | {{speakers[sid].company}}{{speakers[sid].position}}
        </span>
      </h3>
      <h3 class="time" v-if="$store.state.info.displayPresentationTime"><span>时间 : {{presentationTime}}</span></h3>
      <h3 class="location" v-if="lecture.address"><span>会议室 : {{lecture.address}}</span></h3>
      <a v-if="lecture.pptLink" :href="lecture.pptLink" target="_blank" class="ppt"><i class="iconfont icon-ppt"></i></a>
    </div>
    <h1 class="title display-mobile">讲师介绍</h1>
    <speaker
      :speaker-config="speakerConfig"
      :speaker="speakers[sid]"
      :lecture="$store.state.lectures[id]" v-for="(sid, idx) in lecture.speakerIds" :key="idx"></speaker>
    <h1 class="title display-mobile">议题介绍</h1>
    <section class="con-present-info">
      <div class="container">
        <div class="left">
          <h5 v-if="lecture.beginTime && $store.state.info.displayPresentationTime">
            <i class="iconfont icon-time"></i>时间：{{presentationTime}}
          </h5>
          <h5 v-if="lecture.address">
            <i class="iconfont icon-location"></i>地点：{{lecture.address}}
          </h5>
          <h5 v-if="lecture.topicId">
            <i class="iconfont icon-track"></i>
            <template v-if="lecture.topicId">
              <a @click="location(lecture.is_previous, lecture.topicId)">所属专题：{{topics[lecture.topicId].topic}}</a>
            </template>
          </h5>
          <h5 class="tags" v-if="lecture.tag_ids && lecture.tag_ids.length">
            <div>所属领域：</div>
            <template v-if="lecture.tag_ids">
              <span v-for="(tid, indexT) in lecture.tag_ids" :key="indexT">
                {{tags[tid].name + (indexT !== (lecture.tag_ids.length - 1) ? '、': '')}}
              </span>
            </template>
          </h5>
        </div>
        <div class="right">
          <h1>{{lecture.is_previous?'往届演讲：':'演讲：'}}{{lecture.title}}</h1>
          <div class="content" v-html="lecture.introduce">
          </div>
        </div>
      </div>
    </section>

    <section class="con-present-relate display-pc" v-if="relativeLectures.length">
      <div class="container">
        <h2>本专题下其他演讲</h2>
        <ul class="columns is-multiline">
          <li class="column is-one-third" v-for="(lecture, index) in relativeLectures" :key="index">
            <div class="present">
              <router-link :to="'/presentation/' + lecture.id" :class="lecture.speakerIds.length>2?'multi':''">
                <div class="title">{{lecture.title}}</div>
                <div class="relative-bottom" :class="lecture.speakerIds.length>1?'multi':''">
                  <div class="bottom" v-for="(sid, idx) in lecture.speakerIds" :key="idx" v-if="speakers[sid]">
                    <img :src="speakers[sid].avatar+'?imageView2/0/w/800'">
                    <div class="detail">
                      <h4>{{speakers[sid].name}}</h4>
                      <h6>{{speakers[sid].company}}</h6>
                      <h6 class="position">{{speakers[sid].position}}</h6>
                    </div>
                  </div>
                </div>
              </router-link>
              <div class="down">
                <router-link :to="{path: '/search', query: {id: tags[tid].tag_id}}" v-for="(tid, idx) in lecture.tag_ids" class="l-tag" :key="idx" v-html="tags[tid].name"></router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import Speaker from '../com-speaker'
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  components: {
    Speaker
  },
  props: [
    'id'
  ],
  methods: {
    location (ispre, id) {
      if (ispre !== true) {
        this.$router.push({ path: '/track/' + id })
      }
    }
  },
  computed: {
    tags () {
      return this.$store.state.tags
    },
    topics () {
      return this.$store.state.topics
    },
    lecture () {
      return this.$store.state.lectures[this.id] || {
        speaker: {},
        relativeLectureIds: [],
        speakerIds: [],
        relativeManualLectureIds: []
      }
    },
    relativeLectures () {
      return this.lecture.relativeLectureIds ? this.lecture.relativeLectureIds.map(id => this.$store.state.lectures[id]) : []
    },
    speakers () {
      return this.$store.state.speakers
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.lecture.beginTime).utcOffset('+08:00').format('MM月DD日 hh:mm')
    }
  },
  beforeDestroy () {
  }
}
</script>

<style lang="sass" scoped>

.con-present > .title
  // background-color: #2180c2
  background-color: var(--primary-color)
  height: 45px
  line-height: 45px
  font-size: 18px
  color: #fff
  text-align: center

.con-present-info
  background-color: #fff
  padding: 100px 0
  +mobile
    padding: 30px 0
  .container
    display: flex
    justify-content: space-between
    align-items: center
    +mobile
      display: block
  .left
    width: 345px
    padding-right: 30px
    flex-shrink: 0
    +tablet
      padding-left: 30px
    +mobile
      display: none
    h5
      color: #8e9ca9
      font-size: 16px
      line-height: 1.8
      margin-top: 9px
      display: flex
      align-items: center
      // justify-content: flex-end
      i.iconfont
        margin-right: 8px
        color: var(--primary-color)
      &.tags
        display: block
        span
          font-size: 14px
      a
        color: inherit
        &:hover
          color: var(--primary-color)
    +mobile
      width: 100%
      text-align: center
  .right
    flex-grow: 1
    > h1
      color: #3e3a39
      font-size: 38px
      margin-bottom: 50px
      +mobile
        display: none

.con-present-relate
  padding: 59px 0 87px 0
  background-color: #f5f7f8
  h2
    font-size: 24px
    color: #3e3a39
    text-align: center
    margin-bottom: 30px
  .present
    display: block
    // height: 200px
    border: 1px solid #d6dce3
    padding: 20px 15px
    background-color: #fff
    transition: all 0.25s
    &.multi
      height: auto
    &:hover
      box-shadow: 0 0 10px rgba(192, 209, 226, .8)
    a
      .title
        display: block
        font-size: 18px
        color: #3e3a39
        margin-bottom: 15px
    .down
      font-size: 14px
      margin-top: 15px
      .l-tag
        font-size: 12px
        color: #ababab
        padding: 2px 15px
        border: 1px solid #ababab
        border-radius: 15px
        margin-right: 10px
        transition: all 0.3s linear
      .l-tag:hover
        color: var(--primary-color)
        border-color: var(--primary-color)
    .relative-bottom
      &.multi
        .bottom
          margin-top: 10px
          &:first-child
            margin-top: 0
          img
            width: 50px
            height: 50px
          .detail
            h6
              display: inline-block
              margin-top: 5px
      .bottom
        display: flex
        align-items: center
        img
          width: 95px
          height: 95px
          border-radius: 50%
          border: 1px solid #f2f2f2
        .detail
          flex-grow: 1
          margin-left: 15px
          h4
            font-size: 18px
            color: var(--primary-color)
          h6
            font-size: 14px
            color: #8e9ca9
            margin-top: 9px
            line-height: 1.4em
          .position
            margin-top: 3px

.con-present-header
  background: url('./presentation_bg.jpg') no-repeat center
  background-size: 100% 100%
  padding: 34px 25px
  position: relative
  .ppt
    position: absolute
    right: 6vw
    bottom: 30px
    width: 30px
    height: auto
  h2
    color: var(--primary-color)
    font-size: 18px
    font-weight: 900
    margin-bottom: 10px
    .pastTag
      font-size: 14px
  h3.belongstoarea
    font-size: 14px
  h3.belongsto
    display: inline-flex
    border: 1px solid var(--primary-color)
    border-radius: 4px
    padding: 0 9px
    height: 36px
    align-items: center
    font-size: 14px
    margin-bottom: 20px
    a:hover
      color: #2180C2
  .guest, .time, .location
    margin-top: 11px
    font-size: 13px
    color: #3E3A39
    width: 83%
</style>
